import { useQuery } from "@tanstack/react-query"
import { conversationResponsesQuery } from "../lib/conversationResponsesQuery"

export function useConversationResponsesQuery(
  ...args: Parameters<typeof conversationResponsesQuery>
) {
  return useQuery(conversationResponsesQuery(...args))
}
